import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Transformation } from './components/Transformation';
import { Situations } from './components/Situations';
import { PackageContents } from './components/PackageContents';
import { PagePreview } from './components/PagePreview';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
const META_PIXEL_ID = '1782353559454800';
export function App() {
  useMetaPixel(META_PIXEL_ID);
  return <div className="w-full min-h-full bg-cream-100" data-id="element-0" data-mp="28t4j27cxrypu">
      <AnnouncementBar data-id="element-1" data-mp="23vkvggucm9l8" />
      <main data-id="element-2" data-mp="23w4c7u89irxo">
        <Hero data-id="element-3" data-mp="23ujmchww7x65" />
        <StatsBar data-id="element-4" data-mp="23v2r0wxj8p28" />
        <Transformation data-id="element-5" data-mp="23ti864kkyuk7" />
        <Situations data-id="element-6" data-mp="3ik7jmqgv0tve" />
        <PackageContents data-id="element-7" data-mp="3iiweam7rne26" />
        <PagePreview data-id="element-8" data-mp="3ijpbowku4r7n" />
        <Bonuses data-id="element-9" data-mp="3ii4ro0w5cqo1" />
        <Offer data-id="element-10" data-mp="3mlaxx8j9ehui" />
        <Guarantee data-id="element-11" data-mp="3mkre1ma1tjdu" />
        <Testimonials data-id="element-12" data-mp="3mk852v2dm5by" />
        <Faq data-id="element-13" data-mp="3mjpyp5m02aqb" />
      </main>
      <Footer data-id="element-14" data-mp="3rc9co3oln7vn" />
    </div>;
}